import { ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { authInterceptor } from './core/http-interceptors/auth.interceptor';
import { errorInterceptor } from './core/http-interceptors/error.interceptor';
import { BrowserSessionService } from './services/browser-session.service';
import { browserSessionInterceptor } from './core/http-interceptors/browser-session.interceptor';
import { AuthenticationService } from './services/authentication.service';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function provideTranslation() {
  return ({
    loader: {
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [HttpClient]
    },
    defaultLanguage: 'fr'
  });
}

export function appInitializer() {
  const browserSessionService = inject(BrowserSessionService);
  const authenticationService = inject(AuthenticationService);
  sessionStorage.clear();
  browserSessionService.generateSession();
  authenticationService.loadAuthenticationToken();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(appInitializer),
    provideZoneChangeDetection({ runCoalescing: true, eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor, errorInterceptor, browserSessionInterceptor])
    ),
    importProvidersFrom([
      TranslateModule.forRoot(provideTranslation())
    ])
  ]
};
